// API helpers for the Forge module
import axios from "axios";
import { API } from "./api";

const client = axios.create({ baseURL: API, timeout: 30000, withCredentials: true });

export const fetchForgeTemplates = () =>
  client.get(`/forge/templates`).then((r) => r.data);

export const fetchForgeScenarios = () =>
  client.get(`/forge/scenarios`).then((r) => r.data);

export const buildForgeStrategy = (payload) =>
  client.post(`/forge/build`, payload).then((r) => r.data);

export const runStressTest = (payload) =>
  client.post(`/forge/stress-test`, payload).then((r) => r.data);

export const listForgeStrategies = (opts = {}) => {
  const params = {};
  if (opts.status) params.status = opts.status;
  if (opts.playbook) params.playbook = opts.playbook;
  return client.get(`/forge/strategies`, { params }).then((r) => r.data);
};

export const logForgeStrategy = (payload) =>
  client.post(`/forge/strategies`, payload).then((r) => r.data);

export const patchForgeStrategy = (id, payload) =>
  client.patch(`/forge/strategies/${id}`, payload).then((r) => r.data);

export const deleteForgeStrategy = (id) =>
  client.delete(`/forge/strategies/${id}`).then((r) => r.data);

export const fetchForgeAnalytics = () =>
  client.get(`/forge/analytics`).then((r) => r.data);

// Auto-pick the strikes that hit a target POP for the current template.
export const suggestStrikes = (payload) =>
  client.post(`/forge/suggest-strikes`, payload).then((r) => r.data);

// Live option chain (expirations + strike grid) for the Custom Legs editor.
// Path-encodes the symbol so futures roots like "/GC" work.
export const fetchForgeChain = (symbol) =>
  client
    .get(`/forge/chain/${encodeURIComponent(symbol)}`)
    .then((r) => r.data);

// Quick-strike anchors (ATM, ±1σ, ±5%, ±10%) for the leg editor buttons.
export const fetchQuickStrikes = ({ spot, iv = 0.2, dte = 30 }) =>
  client
    .get(`/forge/quick-strikes`, { params: { spot, iv, dte } })
    .then((r) => r.data);

// Rule-based strategy recommender — POSTs the symbol, returns ranked picks
// with rationale + market profile.
export const fetchRecommendations = (symbol, top_n = 5) =>
  client.post(`/forge/recommend`, { symbol, top_n }).then((r) => r.data);

// Save & Share — public read-only links.
export const createShare = (payload) =>
  client.post(`/forge/share`, payload).then((r) => r.data);

export const fetchShare = (id) =>
  client.get(`/forge/share/${id}`).then((r) => r.data);
